var _defs, _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsFertigung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.06 61.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #defc70;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.24,7.08c-.65-3.78-4.25-6.34-8.03-5.68L19.02,7.77c-1.83.31-3.43,1.32-4.51,2.84-1.07,1.52-1.49,3.36-1.18,5.19.3,1.73,1.21,3.19,2.48,4.22l-2.31,8.1-1.98-.51-1.25,5.16,1.65.43-1.06,3.64,5.57,1.51,1.08-3.71,1.89.49,1.25-5.16-1.54-.4,2.31-8.1,21.85-3.75-15.57,29.01h-4.15c-2.56,0-4.65,2.09-4.65,4.65v9.2h32.53v-9.2c0-2.56-2.09-4.65-4.65-4.65h-3.34L60.89,14.25c2.42-1.42,3.85-4.24,3.34-7.17ZM16.15,11.76c.76-1.08,1.9-1.8,3.21-2.02L56.54,3.37c.28-.05.56-.07.84-.07,2.37,0,4.47,1.71,4.88,4.12.46,2.69-1.35,5.26-4.05,5.73l-37.18,6.37c-2.7.45-5.26-1.36-5.73-4.05-.22-1.31.07-2.62.84-3.7ZM18.24,31.5l-.29,1.18-1.25-.32-3.99-1.08.3-1.22,3.16.82,2.08.63ZM15.07,35.9l-1.71-.46.51-1.74,1.72.44-.52,1.76ZM16.68,28.94l-1.23-.37,2.14-7.51c.55.22,1.14.37,1.75.45l-2.16,7.56-.51-.13ZM46.8,48.74c1.46,0,2.65,1.19,2.65,2.65v7.2h-28.53v-7.2c0-1.46,1.19-2.65,2.65-2.65h18.71l.08.04.02-.04h4.42ZM29.99,46.74l15.8-29.44,12.33-2.11-16.94,31.55h-11.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.29,17.36h.04c.76,0,1.47-.29,2.02-.82.55-.54.86-1.26.87-2.04s-.28-1.5-.82-2.06c-.54-.55-1.26-.86-2.03-.87-.77.01-1.5.28-2.06.82s-.86,1.26-.87,2.03c-.02,1.59,1.26,2.91,2.86,2.93ZM19.71,13.83c.17-.16.39-.25.62-.25h.01c.24,0,.46.1.63.27.17.17.26.4.25.63,0,.24-.1.46-.27.63-.17.17-.4.22-.63.25-.49,0-.89-.41-.88-.9,0-.24.1-.46.27-.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.01,11.1h.04c.76,0,1.47-.29,2.02-.82.55-.54.86-1.26.87-2.03,0-.77-.28-1.5-.82-2.06-.54-.55-1.26-.86-2.03-.87-.77,0-1.5.28-2.06.82-.55.54-.86,1.26-.87,2.04s.28,1.5.82,2.06c.54.55,1.26.86,2.03.87ZM56.43,7.57c.17-.16.39-.25.62-.25h.01c.24,0,.46.1.63.27s.26.4.25.63-.1.46-.27.63c-.17.17-.42.25-.63.25-.24,0-.46-.1-.63-.27-.17-.17-.26-.4-.25-.63,0-.24.1-.46.27-.63Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 11.04,
    y: 41.18,
    width: 3,
    height: 2,
    transform: "translate(-31.46 42.88) rotate(-74.36)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 8.06,
    y: 47.13,
    width: 5.62,
    height: 2,
    transform: "translate(-38.41 45.63) rotate(-74.36)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 7.71,
    y: 53.08,
    width: 3,
    height: 2,
    transform: "translate(-45.36 48.37) rotate(-74.36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFertigung);
export default __webpack_public_path__ + "static/media/Icons_Fertigung.34e6db83834146c2acb8c0bb6b8bee40.svg";
export { ForwardRef as ReactComponent };